import {
  IReport7Applicant,
  TReport7Applicant
} from "../../../model/report/report7/Report7Applicant";
import { IReport7NumericValuePresentationModel } from "./Report7NumericValuePresentationModel";

export interface TReport7ApplicantPresentationModel extends TReport7Applicant {
  id: number;
  name: string;
  partyId: string;
  surname: string;
}

export interface IReport7ApplicantPresentationModel
  extends TReport7ApplicantPresentationModel {
  fullName: string;
  numericValues: IReport7NumericValuePresentationModel[];
}

const Report7ApplicantPresentationModel = (
  applicant: IReport7Applicant
): IReport7ApplicantPresentationModel => {
  return {
    ...applicant,
    fullName: `${applicant.name} ${applicant.surname}`,
    numericValues: [] as IReport7NumericValuePresentationModel[]
  };
};

export default Report7ApplicantPresentationModel;
